import initialState from './initialState';
import { OPEN_SNACKBAR, OPEN_SNACKBAR_ERROR, CLOSE_SNACKBAR } from './actionTypes';

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case OPEN_SNACKBAR:
      return {
        error: false,
        message: payload.message,
      };

    case OPEN_SNACKBAR_ERROR:
      return {
        error: true,
        message: (payload && payload.message) || null,
      };

    case CLOSE_SNACKBAR:
      return null;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/Snackbar/reducer.js